import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { EditorSection, Field } from '~/components/promotion/editor-section';
import type { PromotionFormValues } from '~/lib/schemas/promotion';

export function IdentitySection() {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors }
	} = useFormContext<PromotionFormValues>();

	return (
		<EditorSection title={t('promotion.basicInfo.identity.title')} subtitle={t('promotion.basicInfo.identity.subtitle')}>
			<div className="flex flex-col gap-4">
				<Field
					label={t('promotion.basicInfo.identity.name')}
					help={t('promotion.basicInfo.identity.nameHelp')}
					error={errors.name?.message}
					htmlFor="name">
					<Input id="name" {...register('name')} />
				</Field>
				<div className="grid grid-cols-[1fr_140px] gap-4">
					<Field
						label={t('promotion.basicInfo.identity.code')}
						help={t('promotion.basicInfo.identity.codeHelp')}
						error={errors.code?.message}
						htmlFor="code">
						<Input id="code" className="font-mono" {...register('code')} />
					</Field>
					<Field
						label={t('promotion.basicInfo.identity.priority')}
						help={t('promotion.basicInfo.identity.priorityHelp')}
						error={errors.priority?.message}
						htmlFor="priority">
						<Input id="priority" type="number" {...register('priority', { valueAsNumber: true })} />
					</Field>
				</div>
			</div>
		</EditorSection>
	);
}
